import React, { useImperativeHandle, useRef } from 'react';
import AddImageCard from './AddImageCard';
import NoImagesPlaceholder from './NoImagesPlaceholder';
import { FilePlus } from 'lucide-react';

export interface ImageAddingSectionHandle {
  openFilePicker: () => void;
}

interface ImageAddingSectionProps {
  isAddingImage: boolean;
  hasImages: boolean;
  onAddImage: (urls: string[]) => void;
  onCancelAdd: () => void;
  onAddClick: () => void;
  onUploadStatusChange?: (uploading: boolean) => void;
  variant?: 'empty' | 'default';
}

const ImageAddingSection = React.forwardRef<ImageAddingSectionHandle, ImageAddingSectionProps>(
  ({
    isAddingImage,
    hasImages,
    onAddImage,
    onCancelAdd,
    onAddClick,
    onUploadStatusChange,
    variant = 'default',
  }, ref) => {
    const addImageCardRef = useRef<{ openFilePicker: () => void }>(null);

    useImperativeHandle(ref, () => ({
      openFilePicker: () => {
        if (addImageCardRef.current) {
          addImageCardRef.current.openFilePicker();
        }
      }
    }));

    if (!isAddingImage) {
      return hasImages ? null : (
        <NoImagesPlaceholder onAddClick={onAddClick} />
      );
    }

    return (
      <AddImageCard
        ref={addImageCardRef}
        onImageUrlChange={onAddImage}
        onCancel={onCancelAdd}
        onUploadStatusChange={onUploadStatusChange}
        variant="full"
      />
    );
  }
);

export default ImageAddingSection;
